import { lazy } from '@/service/lazy'

export default [{
  name: 'Dashboard',
  path: 'dashboard',
  icon: 'icon-speedometer',
  id: 'dashboard',
  component: lazy('app/default/dashboard/index'),
  meta: { requireAuth: true, rules: ['atender_cliente'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/dashboard.js